module.exports = __webpack_public_path__ + "img/20190711164759QQ截图20190709232453.359c1bd6.png";